export default defineNuxtRouteMiddleware(async (to, from) => {
  if (import.meta.server) {
    return;
  }

  // Avoid running on initial client-side hydration, and on same-page navigations
  const nuxtApp = useNuxtApp();
  if (nuxtApp.isHydrating || to.fullPath === from.fullPath) {
    return;
  }

  const localsStore = useLocalsStore();

  try {
    const data = await $fetch(`/registry/api/meta?url=${encodeURIComponent(to.fullPath)}`);
    if (data) {
      localsStore.$patch({ data });
    }
  } catch (error) {
    console.error('Error fetching meta data:', error);
  }
});
